import React from "react";
import { Badge, StatusBadge } from "../../../ui";
import type { BadgeTone } from "../../../ui";

/**
 * Demo statuses that StatusBadge's map does not know yet (keys are upper-cased).
 * Anything else (COMPLETED, CANCELLED, SCHEDULED, …) goes through StatusBadge.
 */
const DEMO_STATUS_TONES: Record<string, BadgeTone> = {
  ONGOING: "success",
  NOSHOW: "danger",
  NO_SHOW: "danger",
  "STUDENT NO SHOW": "warning",
  "NOT CONDUCTED": "accent",
  NOT_CONDUCTED: "accent",
  RESCHEDULED: "info",
  "AE NOT FOUND": "danger",
};

interface DemoStatusBadgeProps {
  /** Display status string, e.g. from getDisplayDemoStatus / getLiveDemoStatusBadge. */
  status: string;
  /** Optional suffix shown inside the chip (e.g. elapsed minutes). */
  suffix?: string;
}

export const DemoStatusBadge: React.FC<DemoStatusBadgeProps> = ({ status, suffix }) => {
  const raw = `${status ?? ""}`.trim();
  if (!raw || raw === "—") return <span className="ds-text-subtle">—</span>;
  const label = suffix ? `${raw} · ${suffix}` : raw;
  const key = raw.toUpperCase();
  if (key === "ONGOING") {
    return (
      <Badge tone="success" solid className="demo-ops-badge-ongoing">
        {label}
      </Badge>
    );
  }
  if (key === "RESCHEDULED") {
    return (
      <Badge tone="warning" solid className="demo-ops-badge-rescheduled">
        {label}
      </Badge>
    );
  }
  const tone = DEMO_STATUS_TONES[key];
  if (tone) return <Badge tone={tone}>{label}</Badge>;
  return <StatusBadge status={raw} label={label} />;
};

export default DemoStatusBadge;
